module.exports = __webpack_public_path__ + "static/media/loading.2d48e4a8.gif";